import store from 'store';

import { IRequestConfig } from 'models/Axios';
import { CTeData, CTeState } from 'models/CTEs';

import toast from 'components/Toast/dispatch';
import Services from './index.service';
import { createDownloadLink } from 'utils/Download';
import { TableFilterState } from 'components/Table/CTEs/Listing/interface';
import { TableInvoicingCTeFilterState } from 'components/Table/CTEs/Invoicing/interface';
import { TableStockCTeFilterState } from 'components/Table/CTEs/Stock/interface';

export default class CteServices extends Services<CTeData, CTeState> {
  get = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: TableFilterState,
    customerIds?: Array<string | undefined>
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;
    const order = orderby || undefined;

    const orderCte = order?.split(' ').reverse();

    const config: IRequestConfig<CTeState> = {
      url: '/cte/filters',
      params: {
        documentEbl: filter?.documentEbl,
        payerCustomerIds: customerIds?.toString(),
        startPeriod: filter?.startPeriod,
        lastPeriod: filter?.lastPeriod,
        sortBy: orderCte?.[1] || "issueDate",
        sortDirection: orderCte?.[0] || "desc",
        skip: (skip * top),
        top: top,
      },
    };

    return this.httpRequest(config);
  };

  getInvoiceCTe = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: TableInvoicingCTeFilterState,
    customerIds?: Array<string | undefined>
  ) => {
    const { openProtocolCustomer } = store.getState();

    const skip = currentPage || 0;
    const top = pageSize || 20;
    const order = orderby || undefined;

    const orderCte = order?.split(' ').reverse();

    const config: IRequestConfig<CTeState> = {
      url: '/invoice-bill/filters',
      params: {
        customerIds: customerIds?.toString() || openProtocolCustomer?.id,
        startPeriod: filter?.startPeriod,
        lastPeriod: filter?.lastPeriod,
        title: filter?.title,
        sortBy: orderCte?.[1] || "issueDate",
        sortDirection: orderCte?.[0] || "desc",
        skip: (skip * top),
        top: top,
      },
    };

    return this.httpRequest(config);
  };

  getInvoiceItemsCTe = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    idInvoice?: string
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 5;
    const order = orderby || undefined;

    const orderCte = order?.split(' ').reverse();

    const config: IRequestConfig<CTeState> = {
      url: `/invoice-bill/items/${idInvoice}`,
      params: {
        sortBy: orderCte?.[1] || "dueDate",
        sortDirection: orderCte?.[0] || "desc",
        skip: (skip * top),
        top: top
      },
    };

    return this.httpRequest(config);
  };

  getStockCTe = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: TableStockCTeFilterState,
    customerIds?: Array<string | undefined>
  ) => {

    const skip = currentPage || 0;
    const top = pageSize || 20;
    const order = orderby || undefined;

    const orderCte = order?.split(' ').reverse();

    const config: IRequestConfig<CTeState> = {
      url: '/stock/filters',
      params: {
        customerIds: customerIds?.toString(),
        expirationDays: filter?.expirationDate,
        searchProduct: filter?.searchProduct,
        sortDirection: orderCte?.[0] || "desc",
        sortBy: orderCte?.[1] || "id",
        skip: (skip * top),
        top: top,
      },
    };

    return this.httpRequest(config);
  };

  getStockItemsCTe = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    stockId?: string
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 5;
    const order = orderby || undefined;

    const orderCte = order?.split(' ').reverse();

    const config: IRequestConfig<CTeState> = {
      url: `/stock/items/${stockId}`,
      params: {
        sortDirection: orderCte?.[0] || "desc",
        sortBy: orderCte?.[1] || "",
        skip: (skip * top),
        top: top
      },
    };

    return this.httpRequest(config);
  };


  public async downloadData(
    orderby?: string,
    filter?: TableFilterState,
    customerIds?: Array<string | undefined>
  ) {

    const order = orderby ?? undefined;
    const orderCte = order?.split(' ').reverse();

    const config: IRequestConfig<CTeState> = {
      url: '/cte/export-cte-excel',
      params: {
        documentEbl: filter?.documentEbl || "",
        payerCustomerIds: customerIds?.toString(),
        startPeriod: filter?.startPeriod,
        lastPeriod: filter?.lastPeriod,
        top: '99999999',
        skip: 0,
        sortBy: "issueDate",
        sortDirection: orderCte?.[0] || "desc",
      },
      timeout: 300000
    };

    return await this.httpRequest(config)
      .then(result => {
        result.data ?
          createDownloadLink(result.data.fileUrl) :
          toast.error('Desculpe, erro inesperado!');
      })
      .catch(() => toast.error('Desculpe, erro inesperado!'));
  }
}
